import { Component } from '@angular/core';
import { IconComponent } from '@app/components/shared/icon/icon.component';
import { IconName } from '@app/utils/enums/icon-enum';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-cvv-hint-component',
  standalone: true,
  imports: [IconComponent, TranslatePipe],
  templateUrl: './cvv-hint-component.component.html',
  styleUrl: './cvv-hint-component.component.scss',
})
export class CvvHintComponentComponent {
  public readonly iconName = IconName;
}
